import api from "./api";

export default {
  mixins: [ api ],
  methods: {
    // Получение справочников Авито
    async getAvitoDictionaries(data) {
      return await this.get(`job_postings/organization_id/${data.organization_id}/avito/dicts/${data.dictionary_id}`);
    },
    async publishJobPostingAvito(id, payload) {
      return await this.post(`job_postings/id/${id}/publish`, payload);
    },
    // payload пришёл
    async getJobPostingAvitoIntegration(jobPostingId) {
      return await this.get(`job_postings/id/${jobPostingId}/avito_integration`);
    },
    // payload пуст
    async getJobPostingAvitoExternal(jobPostingId) {
      return await this.get(`job_postings/id/${jobPostingId}/external`);
    },
    async updateJobPostingAvitoExternal(id, payload) {
      return await this.post(`job_postings/id/${id}/update_external`, payload);
    },
    async postJobPostingFile(jobPostingId, formData) {
      return await this.post(`job_postings/id/${jobPostingId}/upload_image`, formData);
    },
    // 400
    async getJobPostingAvitoExternalStatus(jobPostingId) {
      return await this.get(`job_postings/id/${jobPostingId}/external_status`);
    },
    /*
     async syncJobPostingAvitoExternal(organizationId) {
      return await this.post(`job_postings/organization_id/${organizationId}/external/sync`);
    },
    async updateJobPostingAvitoDraft(jobPostingId, data) {
      return await this.put(`job_postings/id/${jobPostingId}/avito_integration`, data);
    },
     */
  }
}



// WEBPACK FOOTER //
// ./src/network/avito.js